import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/tools/size-calculator/page.tsx");
